<template>
    <b-overlay :show="tableLoading" rounded="sm" >
        <b-card class="inner-block transaction-type">
            <b-card-header>
                <b-row class="mt-2">
                    <b-col cols="12" class="d-flex">
                        <b-input
                            type="text"
                            :placeholder="$translate('search_transaction_type')"
                            v-model="filter"
                        ></b-input>
                        <slot></slot>
                    </b-col>
                </b-row>
            </b-card-header>
            <b-card-body>
                <b-col class="page-block"
                    ><strong
                        >{{$translate('page')}}: {{ currentPage }} {{$translate('of')}}
                        {{ Math.ceil(rows / itemsPerPage) }} {{$translate('total')}}:
                        {{ rows }}</strong
                    ></b-col
                >
                <b-col class="overflow-auto w-100 mt-4">
                    <b-table
                        :fields="fields"
                        responsive
                        :items="items"
                        :per-page="itemsPerPage"
                        :current-page="currentPage"
                        :filter="filter"
                    >
                        <template>
                            <b-col class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <!-- <strong>{{ $translate('loading') }}</strong> -->
                            </b-col>
                        </template>
                        <template #cell(id)="{ item }">
                            <b-button
                                size="sm"
                                @click="$emit('show-item', item.id)"
                                class="mr-2"
                                v-if="hasPermissionView"
                                variant="pink-button"
                            >
                                <img src="@/assets/images/icon/view.svg" />
                            </b-button>
                        </template>
                        <template #cell(flow)="{ value }">
                            <span>{{ getFlowName(value) }}</span>
                        </template>

                        <template #cell(entity)="{ value }">
                            <span>{{ getEntityName(value) }}</span>
                        </template>

                        <template #cell(reference_entity)="{ value }">
                            <span>{{ getEntityName(value) }}</span>
                        </template>
                    </b-table>
                </b-col>
            </b-card-body>
            <b-row>
                <b-col>
                    <b-pagination
                        class="justify-content-center mt-4"
                        :prev-text="$translate('preview')"
                        :next-text="$translate('next')"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="itemsPerPage"
                        aria-controls="roleTable"
                        pills
                        align="right"
                    ></b-pagination>
                </b-col>
            </b-row>
        </b-card>
    </b-overlay>
</template>
<script>
import permissionsMixins from '@/mixins/permissionsMixins'
import popupMixins from '@/mixins/popupMixins'

export default {
    name: 'transactionTypes-ListItems',
    mixins: [popupMixins, permissionsMixins],
    props: ['items', 'title'],

    data() {
        return {
            filter: '',
            itemsPerPage: 15,
            tableLoading: false,
            currentPage: 1,
        }
    },

    mounted() {
        this.doSearch()
    },
    watch: {
        items: {
            handler: function () {
                this.tableLoading = false
            },
            deep: true,
        },
    },
    computed: {
        fields() {
            return [
                { key: 'id', label: this.$translate('actions') },
                { key: 'name', label: this.$nameLabel() },
                { key: 'entity', label: this.$translate('entity') },
                { key: 'flow', label: this.$translate('flow'), },
                { key: 'reference_entity', label: this.$translate('reference') },
            ]
        },
        user() {
            return this.$store.state.user
        },
        permissions() {
            return this.$store.state.rolePermissions
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
        flowOptions() {
            return this.$store.getters['transactionType/flowOptions']
        },

        entityOptions() {
            return this.$store.getters['transactionType/entityOptions']
        },

        rows() {
            return this.items.length
        },
    },

    methods: {
       async doSearch() {
            this.tableLoading = true
           await this.$store.dispatch('transactionType/fetchAll')
        },

        getEntityName(value) {
            if (value == -1) return 'Loss Vault'
            return (this.entityOptions.find(x => x.value === value) || {}).text
        },

        getFlowName(value) {
            return (this.flowOptions.find(x => x.value === value) || {}).text
        },
    },
}
</script>
<style></style>
